import { PageTitle } from '@/buyer-portal/components/PageTitle'
import { type ListingDetails } from '@/queries/listingDetailsQuery'

import { ListingDetailsPageLoaded } from './ListingDetailsPageLoaded'
import { ListingTermsAcceptanceGuard } from './ListingTermsAcceptanceGuard'
import { ListingTypeGuard } from './ListingTypeGuard'

export const ListingDetailsPageContents = ({
  referral_url,
  listing,
  initialBidAmount,
}: {
  listing: ListingDetails
  referral_url: string
  initialBidAmount: string | undefined
}) => {
  return (
    <>
      <PageTitle value={[listing.lot.title, listing.seller.storefront?.name]} />

      <ListingTypeGuard listing={listing}>
        <ListingTermsAcceptanceGuard listing={listing}>
          <ListingDetailsPageLoaded
            referral_url={referral_url}
            initialBidAmount={initialBidAmount}
            listing={listing}
          />
        </ListingTermsAcceptanceGuard>
      </ListingTypeGuard>
    </>
  )
}
